import Decimal from 'decimal.js'
import { toast } from 'react-toastify'

import {
  GetDistanceCalculationQuery,
  GoogleDistanceStatus,
  useGetDistanceCalculationLazyQuery,
} from 'generated/graphql'
import { findReturnStopIndex } from 'helpers'

const useMapDistanceCalculation = (
  bookingAddresses: any,
  setValue: any,
  isWaitAndReturn: boolean,
) => {
  const handleDistanceCalculation = (
    data: GetDistanceCalculationQuery,
    distanceType: 'distance' | 'returnDistance',
  ) => {
    const { status, distance: rawDistance, errorMessage } = data.distanceCalculation

    if (status === GoogleDistanceStatus.Success) {
      const distance = new Decimal(rawDistance).toDP(2, Decimal.ROUND_FLOOR).toNumber()

      setValue(distanceType, distance)
    } else if (status === GoogleDistanceStatus.Error) {
      toast.warning(errorMessage)
    }
  }

  const [
    getDistanceCalculation,
    { data: distanceCalculationData, loading: distanceCalculationLoading },
  ] = useGetDistanceCalculationLazyQuery({
    // onCompleted: (data) => {
    //   handleDistanceCalculation(data)
    // },
    onError: (error) => {
      toast.error(error.message)
    },
  })

  const calculateDistance = (addresses: Array<{ id: string }>) => {
    const orderedAddresses = addresses.map(
      (address) => bookingAddresses?.find((ba) => ba.id === address.id)?.address,
    )

    const googleAddressInput = addresses.map((address, index) => {
      const bookingAddressNew = bookingAddresses?.find((ba) => ba.id === address.id)

      return {
        sequenceOrder: index,
        addressLine1: bookingAddressNew?.address.addressLine1,
        ...(bookingAddressNew?.address.addressLine2 && {
          addressLine2: bookingAddressNew?.address.addressLine2,
        }),
        postcode: bookingAddressNew?.address.postcode,
        city: bookingAddressNew?.address.city,
        countryId: bookingAddressNew?.address.countryId,
      }
    })

    getDistanceCalculation({ variables: { input: googleAddressInput } }).then(
      ({ data }) => data && handleDistanceCalculation(data, 'distance'),
    )

    // Finds the last delivery matching the collection location after the route is reordered.
    // The leg immediately before that stop is used as the Wait & Return distance.
    const [collection, ...stops] = orderedAddresses
    const returnStopIndex = isWaitAndReturn ? findReturnStopIndex(stops, collection) : -1

    if (returnStopIndex !== -1) {
      const returnLeg = googleAddressInput.slice(returnStopIndex, returnStopIndex + 2)

      getDistanceCalculation({ variables: { input: returnLeg } }).then(
        ({ data }) => data && handleDistanceCalculation(data, 'returnDistance'),
      )
    } else {
      setValue('returnDistance', 0, { shouldDirty: true })
    }
  }

  return {
    calculateDistance,
    distanceCalculationData,
    distanceCalculationLoading,
  }
}

export default useMapDistanceCalculation
